import { render, staticRenderFns } from "./Comment.vue?vue&type=template&id=5dbe191d&scoped=true"
import script from "./Comment.vue?vue&type=script&lang=ts"
export * from "./Comment.vue?vue&type=script&lang=ts"
function injectStyles (context) {
  
  var style0 = require("./Comment.vue?vue&type=style&index=0&id=5dbe191d&prod&lang=scss&scoped=true")
if (style0.__inject__) style0.__inject__(context)

}

/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "5dbe191d",
  "73d84e00"
  
)

export default component.exports